import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import theme from "./styling/theme";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Navbar />
        <AppWrapper>
          <Switch>
            <Route path="/" component={Home} exact />
            <Route path="/contactus" component={ContactUs} exact />
            {/* <Route path="/signin" component={SigninPage} exact /> */}

            <Redirect to="/" />
          </Switch>
        </AppWrapper>
        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;

const AppWrapper = styled.div`
  @media screen and (min-width: 577px) {
    margin-left: 80px;
  }
  background: ${({ theme }) =>
    "linear-gradient(to right, " +
    theme.color3 +
    " calc(100% - 2px), " +
    theme.color1 +
    "18 " +
    0 +
    ")"};
  background-size: calc((100% - 6 * 2px) / 7 + 2px) 100%;
`;
